jQuery(function ($) {
  //Function for Tab Focus Menu
  function lockFocus(e) {
    const isTabPressed = e.key === "Tab" || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    e.preventDefault();

    if (focusableElements.length == 1) {
      focusableElements[0].trigger("focus");
    } else {
      // console.log('focusableElementsCurrentIndex', focusableElementsCurrentIndex);
      if (e.shiftKey) {
        focusableElementsCurrentIndex--;

        if (focusableElementsCurrentIndex < 0) {
          focusableElementsCurrentIndex = focusableElements.length - 1;
        }
      } else {
        focusableElementsCurrentIndex++;

        if (focusableElementsCurrentIndex >= focusableElements.length) {
          focusableElementsCurrentIndex = 0;
        }
      }

      $.each(focusableElements, function () {
        $(this).removeClass("force-focus");
      });

      // console.log("ff", focusableElements[focusableElementsCurrentIndex]);

      $(focusableElements[focusableElementsCurrentIndex]).trigger("focus");
      $(focusableElements[focusableElementsCurrentIndex]).addClass(
        "force-focus"
      );

      // if ($(focusableElements[focusableElementsCurrentIndex]).is('.type-ttle')) {
      //   $(focusableElements[focusableElementsCurrentIndex]).addClass('force-focus');
      // }

      const focusableElement = $(".force-focus")[0];

      if (focusableElement) {
        focusableElement.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "nearest",
        });
      }
    }
  }

  // document.addEventListener("focusin", (event) => {
  //   console.log("Focused element:", event.target);
  // });

  //Hamburger menu
  $("#menu-show").on("click", function () {
    var isExpanded = $(this).attr("aria-expanded") === "true";
    $(this).attr("aria-expanded", isExpanded ? "false" : "true");

    $("#hamburger-menu").toggle();

    var hamburgerImg = $("#menu-show img");
    var menuText = $("#menu-show p");
    var windowH = $(window).height();

    $("#hamburger-menu .scroll-area").css("height", windowH - 150);

    if ($("#hamburger-menu").is(":visible")) {
      // console.log('hamburg is visible')

      //add class to hamburgermenu
      $("#hamburger-menu").addClass("hamburgermenu-open");
      $("#hamburger-utilities").addClass("hamburger-utilities-visible");

      hamburgerImg.attr(
        "src",
        "themes/custom/tema/src/assets/icons/close-icon.svg"
      );
      menuText.text("SLUITEN");
      $("body").css("overflow", "hidden"); // Disable scrolling

      $("#menu-show").toggleClass("menu-btn-trigger menu-close");

      $(".type-title").on("click keydown", function (e) {
        if (
          e.type === "click" ||
          (e.type === "keydown" && (e.key === "Enter" || e.which === 13))
        ) {
          if (!$(e.target).is("a")) {
            console.log("type?");

            var faqTitle = $(this);
            var faqBody = faqTitle.next(".type-body");
            var isExpanded = faqBody.is(":visible");

            faqBody.slideToggle(500);
            faqTitle.find(".arrow-icon").toggleClass("rotate-180");

            faqTitle.find(".arrow-icon").toggleClass("collapsed", !isExpanded);
            faqTitle.attr("aria-expanded", !isExpanded);
            $(".menu-item").attr("aria-expanded", "false");
            faqBody.attr("aria-hidden", isExpanded);

            if (!isExpanded) {
              focusableElements = [];
              faqBody.find("a").each(function () {
                focusableElements.push(this);
              });

              // focusableElements.push(faqTitle);

              focusableElements.push(faqTitle[0]);
              faqTitle.find("a").each(function () {
                focusableElements.push(this);
              });

              focusableElementsCurrentIndex = -1;
            } else {
              focusableElements = [];
              focusableElementsCurrentIndex = 0;
              getHamburgerMenuTab();
            }
          }
        }
      });

      const modalmobileTranslate = $(".translate-menu-mobile");
      const triggermobileTranslate = $(".button-open-translate-mobile");
      const closebuttonmobileTranslate = $(".button-close-translate-mobile");

      function showTranslate() {
        triggermobileTranslate.attr("aria-pressed", true);
        triggermobileTranslate.attr("aria-expanded", true);
        modalmobileTranslate.addClass("expanded");
        modalmobileTranslate.show();

        focusableElements = [];

        const focusableSelector = "a[href], select:not([disabled])";
        const focusableInModal = modalmobileTranslate.find(focusableSelector);

        focusableInModal.each(function () {
          focusableElements.push($(this));
        });

        focusableElements.push(closebuttonmobileTranslate);
        focusableElements.push(modalmobileTranslate);

        focusableElementsCurrentIndex = 0;

        // console.log("translateeee", focusableElements);

        $(document).on("keydown", lockFocus);
      }

      function closeTranslate() {
        triggermobileTranslate.attr("aria-pressed", false);
        triggermobileTranslate.attr("aria-expanded", false);
        modalmobileTranslate.removeClass("expanded");
        modalmobileTranslate.hide();

        focusableElementsCurrentIndex = -1;
        $(document).off("keydown", lockFocus);
      }

      $(".button-open-translate-mobile").on("click keydown", function (e) {
        if (
          e.type === "click" ||
          (e.type === "keydown" && (e.key === "Enter" || e.which === 13))
        ) {
          showTranslate();
        }
      });

      $(".button-close-translate-mobile").on("click keydown", function (e) {
        if (
          e.type === "click" ||
          (e.type === "keydown" && (e.key === "Enter" || e.which === 13))
        ) {
          closeTranslate();
          focusableElements = [];
          focusableElementsCurrentIndex = 0;
          getHamburgerMenuTab();
        }
      });

      // Fokus management setup (this code will run elsewhere as needed)
      focusableElements = [];

      function getHamburgerMenuTab() {
        focusableElements.push($("#menu-show"));

        $(".nav-desktop-hamburger .menu .menu-item").each(function () {
          // Check for 'content-nav-type' class
          if ($(this).hasClass("content-nav-type")) {
            focusableElements.push($(this).find(".type-title a")); // Add the type-title link

            var bodyMenu = $(this).find(".type-body");
            if (bodyMenu.length) {
              // Only if bodyMenu is visible
              focusableElements.push($(this).find(".type-title"));
            }
          }

          // Check for 'has-dropdown' but not 'content-nav-type'
          if (
            $(this).hasClass("has-dropdown") &&
            !$(this).hasClass("content-nav-type")
          ) {
            focusableElements.push($(this).find("> a")); // Add the direct anchor child

            var subMenu = $(this).find(".sub-menu"); // Find the sub-menu
            if (subMenu.length) {
              subMenu.find("a").each(function () {
                focusableElements.push($(this)); // Add each anchor in the sub-menu
              });
            }
          }

          // Specifically add anchors for menu items with ID 7 and 8
          if (
            $(this).hasClass("menu-item--7") ||
            $(this).hasClass("menu-item--8")
          ) {
            focusableElements.push($(this).find("a")); // Add the anchor for "Over" menu item
          }
        });

        focusableElements.push($(".search-button"));
        focusableElements.push($(".button-lettergrootte"));
        focusableElements.push($(".button-open-translate-mobile"));

        focusableElementsCurrentIndex = -1;
      }

      getHamburgerMenuTab();
      // console.log("ham", focusableElements);
      document.addEventListener("keydown", lockFocus);
    } else {
      $("#hamburger-menu").removeClass("hamburgermenu-open");
      $("#hamburger-utilities").removeClass("hamburger-utilities-visible");

      hamburgerImg.attr(
        "src",
        "themes/custom/tema/src/assets/icons/hamburger-menu.svg"
      );
      menuText.text("MENU");
      $("body").css("overflow", "auto"); // Enable scrolling

      $("#menu-show").toggleClass("menu-btn-trigger menu-close");

      //fokus
      focusableElementsCurrentIndex = -1;
      document.removeEventListener("keydown", lockFocus);
    }
  });
  //END Hamburger menu

  //Contrast Button
  var themeToggleButtons = document.querySelectorAll(".theme-toggle-button");
  var htmlElement = document.documentElement;

  themeToggleButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      htmlElement.classList.toggle("dark");
      var isDarkMode = htmlElement.classList.contains("dark");
      // Store the dark mode state in localStorage
      localStorage.setItem("darkMode", isDarkMode);
    });
  });
  //END Contrast Button

  //Menu tab fokus
  $(".menu--de-her .menu .menu-item.has-dropdown > a").on(
    "click",
    function (event) {
      event.preventDefault();
    }
  );

  $(".menu .menu-item.has-dropdown").on("click keydown", function (event) {
    if (!$(this).hasClass("active")) {
      $(".menu .menu-item.has-dropdown.active").removeClass("active");

      if (
        event.type === "click" ||
        (event.type === "keydown" && event.which === 13)
      ) {
        $(this).addClass("active");
        $(this).attr("aria-expanded", "true");
      }
    }

    // if (event.key === 'Tab') {
    //   // Get the currently focused element
    //   var focusedElement = document.activeElement;
    //   console.log('Focused Element:', focusedElement);
    // }
  });
  //END Menu tab fokus

  $(document).on("click", function (e) {
    // Check if the clicked element is not part of the menu-item or sub-menu
    if (!$(e.target).closest(".menu-item, .sub-menu").length) {
      // Find all .menu-item elements with the class 'active' and remove the class
      $(".menu-item.active").removeClass("active");
      $(".menu-item").attr("aria-expanded", "false");
    }
  });
}); //js
